<template>
  <div class="panel panel-default">
    <div class="panel-heading">{{ caixaAlta(limitar(convenio.nome, 30)) }}</div>
    <div class="panel-body panel_info">
      <table class="table table-striped table-hover tabela_info">
        <tbody>
          <tr v-if="convenio.tabelas.length">
            <td colspan="2">
              <p :class="{ unica_linha: convenio.tabelas.length < 3 }">
                <strong>Procedimentos</strong>:
                <span
                  v-for="(tabela, index) in convenio.tabelas"
                  :key="tabela._id"
                >
                  <span v-if="index <= 3">
                    {{ tabela.nome }}
                    <span
                      v-if="
                        convenio.tabelas.length > 1 && index >= 0 && index <= 2
                      "
                      >,
                    </span>
                  </span>
                </span>
                <span v-if="convenio.tabelas.length > 3">
                  e outras {{ convenio.tabelas.length - 3 }} tabelas.</span
                >
              </p>
            </td>
          </tr>
          <tr v-if="convenio.tabelas.length === 0">
            <td colspan="2"
              ><p class="unica_linha">Nenhuma tabela de procediemntos</p></td
            >
          </tr>
          <tr>
            <td><strong>Situação</strong></td>
            <td :class="convenio.ativo ? 'text-success' : 'text-danger'">{{
              convenio.ativo ? 'Ativo' : 'Cancelado'
            }}</td>
          </tr>
        </tbody>
      </table>
      <div class="btn-group btn-group-justified" role="group">
        <RouterLink
          id="editar"
          data-test-id="link-editar"
          :to="'/convenio/cadastro/' + convenio._id"
          name="editar"
          role="button"
          class="btn btn-sm btn-default"
        >
          <span class="fa fa-edit" />
          Editar
        </RouterLink>
      </div>
    </div>
  </div>
</template>

<script>
import * as formatadores from '@/utils/formatadores'

export default {
  name: 'ConvenioFicha',
  props: {
    convenio: {
      type: Object,
      required: true,
      validator: (value) => {
        return value && value._id
      },
    },
  },
  methods: {
    ...formatadores,
  },
}
</script>

<style>
.unica_linha {
  margin: 13px 6px;
}
</style>
